import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { PROJECTS_BY_ORG_KEY } from '@/utils/queryKeys.ts';
import { AxiosError } from 'axios';
import { get_projects_by_organization_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { ProjectsByOrg } from '@/types/common.ts';

const useRetrieveProjectsByOrg = (): UseQueryResult<ProjectsByOrg, AxiosError> => {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: PROJECTS_BY_ORG_KEY,
    queryFn: async () => {
      const response = await apiClient.get(get_projects_by_organization_url());
      return response.data;
    },
    // enabled: !!orgId, // Prevents running query if orgId is undefined/null
  });
};

export default useRetrieveProjectsByOrg;
